// POISONING FOLDS OUT OF THE CHAIN LIST (his "help me fixing address poisoning and books poisoning", 4 Nov 2026, with a
// screenshot of 3 Nov: look-alikes of Bitget's and KuCoin's addresses and dust outnumbered the real rows from 14:47 to
// 15:59). The chain sync already parks them as Ignored, with its reason on the row (bff/src/routes/chain.ts: the
// look-alike park, DUST_NOTE, the "Address poisoning —" park), and never books them. The screen folds them: per Dubai
// day ONE line in their place, "5 poisoning attempts hidden", and a tap shows them. Nothing is deleted, they stay in KYT,
// a look-alike keeps its red line and no row offers Copy. A row a person ignored for any other reason stays in the list.
import { dubaiDate } from './format';

type Row = { status: string; note: string | null; lookalike_of?: string | null; block_time: string };

/** The notes the chain sync writes when it parks poisoning — the look-alike park, the dust park, the trivial-receipt park —
 *  and the hand reason "Dust or a spam token" (IGNORE_REASONS). */
const SYNC_PARKS = /^(Lookalike of |Dust — |Dust or a spam token|Address poisoning — )/;

/** Ignored as a look-alike or as dust: folded out of the list. */
export const isPoisonRow = (r: Row): boolean => r.status === 'ignored' && (!!r.lookalike_of || SYNC_PARKS.test(r.note ?? ''));

export type ChainRun<R> = { kind: 'shown'; rows: R[] } | { kind: 'hidden'; day: string; rows: R[] };

/** The list in its own order, each day's poisoning gathered into one run where its first row stood. */
export function foldPoison<R extends Row>(rows: readonly R[]): ChainRun<R>[] {
  const out: ChainRun<R>[] = [];
  const days = new Map<string, { kind: 'hidden'; day: string; rows: R[] }>();
  for (const r of rows) {
    if (isPoisonRow(r)) {
      const day = dubaiDate(r.block_time);
      let run = days.get(day);
      if (!run) { run = { kind: 'hidden', day, rows: [] }; days.set(day, run); out.push(run); }
      run.rows.push(r);
      continue;
    }
    const last = out[out.length - 1];
    if (last?.kind === 'shown') last.rows.push(r); else out.push({ kind: 'shown', rows: [r] });
  }
  return out;
}

export const hiddenWords = (n: number): string => `${n} poisoning attempt${n === 1 ? '' : 's'} hidden`;
